.uom-image {
  &__picture {
    display: block;
    width: 100%;
  }

  &__img {
    display: block;
    object-fit: cover;
    width: 100%;
  }

  &__caption {
    color: var(--palette-foreground-secondary);
    font: use-font-secondary("400 12px/16px");
    overflow-wrap: anywhere;
    padding: 8px 15px;
  }
}